export type TechnicalCommissionStatus = "NOT_COUNTED" | "UNPAID" | "PAID";
export type TechnicalCommissionScope = "technical" | "chuong" | "dung";

export const technicalCommissionStatusTrans: Record<
  TechnicalCommissionStatus,
  { label: string; color: string; bgcolor: string }
> = {
  NOT_COUNTED: { label: "Không tính HH", color: "#667085", bgcolor: "#f2f4f7" },
  UNPAID: { label: "Chưa trả HH", color: "#b54708", bgcolor: "#fffaeb" },
  PAID: { label: "Đã trả HH", color: "#027a48", bgcolor: "#d1fadf" },
};

export const technicalCommissionStatusOptions = (
  Object.keys(technicalCommissionStatusTrans) as TechnicalCommissionStatus[]
).map((value) => ({ value, label: technicalCommissionStatusTrans[value].label }));

export interface TechnicalCommissionRow {
  id: number;
  content: string;
  debtCount: number;
  amount: number;
  preTaxAmount: number;
  dueDate: string;
  collectedDate: string;
  technicalCommissionStatus: TechnicalCommissionStatus | null;
  technicalCommissionPaidAt: number;
  commissionChuong: number;
  commissionDung: number;
  order: {
    id: number;
    code: string;
    contractCode: string;
    opportunityCode: string;
    opportunityName: string;
  } | null;
  customer: { id: number; name: string } | null;
}

export interface TechnicalCommissionRates {
  chuong: number;
  dung: number;
}
